import { useState, useEffect, useCallback } from 'react';

const POLL_INTERVAL = 60000;

export function useUserStatus({ enabled = true } = {}) {
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(null);

    const fetchStatus = useCallback(async () => {
        try {
            const headers = {};
            const sessionToken = sessionStorage.getItem('cv_session_token');
            if (sessionToken) {
                headers['Authorization'] = `Bearer ${sessionToken}`;
            }
            const response = await fetch('/api/user/status', {
                credentials: 'include',
                headers
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch status');
            }
            
            const data = await response.json();
            if (data.success || data.tier) {
                setStatus(data);
                setError(null);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!enabled) {
            setLoading(false);
            return undefined;
        }

        fetchStatus();

        const interval = setInterval(fetchStatus, POLL_INTERVAL);

        const handleAnalysis = () => {
            setTimeout(fetchStatus, 1000);
        };

        window.addEventListener('analysisComplete', handleAnalysis);

        return () => {
            clearInterval(interval);
            window.removeEventListener('analysisComplete', handleAnalysis);
        };
    }, [enabled, fetchStatus]);

    const refresh = useCallback(() => {
        setLoading(true);
        return fetchStatus();
    }, [fetchStatus]);

    return { status, loading, error, refresh };
}

export default useUserStatus;
